// https://lincolnprofilev9.cms.dealer.com/2023-lincoln-navigator.htm
export default {
	events: {
		widgetUserEvent: [
			{
				logic: ({ eventData }) => {
					const { result, widgetName } = eventData;

					return (
						result === 'Opens gallery modal' &&
						widgetName === 'ws-media-viewer'
					);
				},
				payload: ({ eventData }) => ({
					directCall: 'global-onclick',
					payload: {
						page: {
							pageName:
								'research models:why buy:lincoln navigator',
							pageNameNoVehicle: 'research models:why buy'
						},
						onclick: {
							onclick: `research models:why buy:content:photo click:${
								eventData?.widgetIntention === 'exterior photos'
									? 'ext'
									: 'int'
							}`,
							onclickLinkName:
								'research models:why buy:content:action'
						},
						vehicle: {
							modelYear: '2023',
							nameplate: 'lincoln navigator'
						}
					}
				})
			}
		]
	}
};
